import React, { useState } from "react";
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { RoundedDropdowns,Primary, Href } from "../../../../Constant";
import { ROUNDED_DATA, ROUNDED_LIST } from "../../../../Data/UiKit/Dropdown";
import CommonDropDown from "../Common/CommonDropDown";

const RoundedDropdown = () => {
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen(!open);
  
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={RoundedDropdowns} span={ROUNDED_DATA} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <div className="btn-group">
              <Dropdown isOpen={open} toggle={toggle}>
                <DropdownToggle caret color="primary" className="rounded-pill">{Primary}</DropdownToggle>
                <DropdownMenu className="dropdown-block">
                  <DropdownItem href={Href}>Dark</DropdownItem>
                  <DropdownItem href={Href}>Light</DropdownItem>
                  <DropdownItem href={Href}>Lighter</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            {ROUNDED_LIST.map((data, index) => (
              <CommonDropDown key={index} item={data} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  )
};

export default RoundedDropdown;